import { Link, useLocation, useNavigate } from 'react-router-dom';
import React, { useContext, useState, useEffect } from "react";
import { 
  FaHome, 
  FaCalendarAlt, 
  FaBuilding, 
  FaRobot, 
  FaEnvelope, 
  FaCreditCard, 
  FaSignOutAlt,
  FaQuestionCircle,
  FaComments
} from 'react-icons/fa';
import '../../assets/css/layout/customer/CustomerSidebar.css';
import AppContext from '../../context/AppContext';

const CustomerSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {setLoggedInCustomer} = useContext(AppContext);

  const isActive = (path) => location.pathname === path;

  const menuItems = [
    { title: 'Dashboard',      icon: <FaHome />,           path: '/customer/dashboard'      },
    // { title: 'My Events',      icon: <FaCalendarAlt />,    path: '/customer/my-events'      },
    { title: 'My Bookings',    icon: <FaBuilding />,       path: '/customer/my-bookings'    },
    { title: 'Chat',           icon: <FaComments />,       path: '/customer/chat'           },
    // { title: 'AI Planner',     icon: <FaRobot />,          path: '/customer/ai-plannar'     },
    // { title: 'Invitations',    icon: <FaEnvelope />,       path: '/customer/invitations'    },
    { title: 'Payments',       icon: <FaCreditCard />,     path: '/customer/payments'       },
    { title: 'HelpandSupport', icon: <FaQuestionCircle />, path: '/customer/helpandsupport' },
  ];

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/customer/login'); 
  };

  useEffect (()=>{
    const customer = JSON.parse(localStorage.getItem("loggedInCustomer"))
    setLoggedInCustomer(customer);
  },[])

  return (
    <div className="customer-sidebar-container">

      {/* Header */}
      <div className="customer-sidebar-header">
        <Link to="/" className="customer-sidebar-logo" style={{ textDecoration: 'none' }}>
          <div className="customer-sidebar-logo-icon">
            <span className="customer-sidebar-logo-letter">E</span>
          </div>
          <div className="customer-sidebar-logo-text">
            <h4 className="customer-sidebar-title">EVENT MANAGEMENT</h4>
            <p className="customer-sidebar-subtitle">Customer Panel</p>
          </div>
        </Link>
      </div>

      {/* Menu */}
      <div className="customer-sidebar-menu">
        {menuItems.map((item, index) => (
          <div key={index} className="customer-sidebar-menu-item">
            <Link
              to={item.path}
              className={`customer-sidebar-link ${isActive(item.path) ? 'customer-sidebar-active' : ''}`}
            >
              <span className="customer-sidebar-icon">{item.icon}</span>
              <span className="customer-sidebar-text">{item.title}</span>
            </Link>
          </div>
        ))}

        {/* ✅ LOGOUT — no inline style, CSS class handles everything */}
        <div className="customer-sidebar-menu-item">
          <button
            className="customer-sidebar-link customer-sidebar-logout"
            onClick={handleLogout}
          >
            <span className="customer-sidebar-icon"><FaSignOutAlt /></span>
            <span className="customer-sidebar-text">Logout</span>
          </button>
        </div>

      </div>
    </div>
  );
};

export default CustomerSidebar;